<template>
  <v-card elevation="0" :loading="chartLoading" height="240">
    <v-card-text>
      <chart type="area" height="220" :options="chart.options" :series="chart.series" />
    </v-card-text>
  </v-card>
</template>

<script>
  /**
   * @author Ali Hüseyin ŞİRELİ
   * @email ali.sireli@globme.com.tr
   * @create date 2021-03-31 15:37:07
   * @modify date 2021-03-31 15:37:07
   * @desc LatelyChart
   */
  export default {
    name: "LatelyChart",
    props: {
      workplans: Array,
      chartLoading: Boolean
    },
    data: vm => ({
      chart: {
        options: {
          chart: {
            type: "area",
            width: "100%",
            sparkline: {
              enabled: true
            }
          },
          stroke: {
            curve: "smooth"
          },
          fill: {
            opacity: 0.4
          },
          labels: [],
          yaxis: {
            min: 0,
            show: false
          },
          xaxis: {
            type: "datetime"
          },
          colors: ["#ff0000"],
          title: {
            text: "",
            offsetX: 30,
            style: {
              fontSize: "24px",
              cssClass: "apexcharts-yaxis-title"
            }
          },
          subtitle: {
            text: vm.$t("dashboard.access.total_tardiness_average"),
            offsetX: 30,
            style: {
              fontSize: "14px",
              cssClass: "apexcharts-yaxis-title"
            }
          }
        },
        series: []
      }
    }),
    watch: {
      workplans: {
        deep: true,
        handler(workplans) {
          this.renderChart(workplans);
        }
      }
    },
    methods: {
      renderChart(workplans) {
        let timesheets = workplans.filter(
          item => !item.countAsOvertime && item.assignedShifts.length && !item.leaveRequest && item.timesheets.length
        );
        let lates = [];
        timesheets.forEach(workplan => {
          let lately = workplan.timesheets.filter(item => item.latelyClockInTimeInMinutes);
          if (lately.length) {
            lates.push({
              date: workplan.date,
              totalMinutes: lately.reduce((acc, item) => acc + item.latelyClockInTimeInMinutes, 0) / lately.length
            });
          }
        });
        const lateAverage = (lates.reduce((acc, item) => acc + item.totalMinutes, 0) / lates.length).toFixed(0);
        this.chart.options = {
          ...this.chart.options,
          labels: lates.map(item => item.date),
          title: {
            text: isNaN(lateAverage)
              ? 0 + ` ${this.$t("dashboard.access.short_minute")}`
              : lateAverage + ` ${this.$t("dashboard.access.short_minute")}`
          }
        };
        this.chart.series = [
          {
            name: this.$t("dashboard.access.tardiness_minute"),
            data: lates.map(item => item.totalMinutes)
          }
        ];
      }
    },
    created() {
      this.renderChart(this.workplans);
    }
  };
</script>

<style></style>
